import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getSystemRolesList } from '@/service/systemControl'

const initialState = {
  fetching: false,
  error: null,
  list: []
}

/**
 * 拉取角色列表。首个参数为 GET 查询对象，原样传给 getSystemRolesList；不传则等价于 `{}`。
 * @param {Record<string, unknown>} [query={}]
 */
export const fetchSystemRolesList = createAsyncThunk(
  'systemRole/fetchList',
  async (query = {}, { rejectWithValue }) => {
    try {
      const res = await getSystemRolesList(query)
      const rows = Array.isArray(res?.data) ? res.data : []
      return rows
    } catch (error) {
      const msg =
        error?.message ||
        error?.response?.data?.msg ||
        '加载角色列表失败'
      return rejectWithValue(msg)
    }
  }
)

const systemRoleSlice = createSlice({
  name: 'systemRole',
  initialState,
  reducers: {
    resetSystemRoleList: (state) => {
      state.list = []
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystemRolesList.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchSystemRolesList.fulfilled, (state, action) => {
        state.fetching = false
        state.list = action.payload
        state.error = null
      })
      .addCase(fetchSystemRolesList.rejected, (state, action) => {
        state.fetching = false
        state.list = []
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export const { resetSystemRoleList } = systemRoleSlice.actions
export default systemRoleSlice.reducer
